import { render, staticRenderFns } from "./multiChoiceQuestionInput.vue?vue&type=template&id=32634456&"
import script from "./multiChoiceQuestionInput.vue?vue&type=script&lang=js&"
export * from "./multiChoiceQuestionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('32634456', component.options)
    } else {
      api.reload('32634456', component.options)
    }
    module.hot.accept("./multiChoiceQuestionInput.vue?vue&type=template&id=32634456&", function () {
      api.rerender('32634456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/UserProfile/Scripts/Inputs/multiChoiceQuestionInput.vue"
export default component.exports